import { IResult, TrackingProperties, ActivitiesEntryTypeEnum } from "redmond";

export interface TripDestination {
  location: IResult;
  tripDate: string;
  tripEndDate: string;
  source: "Flight" | "Hotel";
  coordinates: { lat: number; lon: number };
  displayName: string;
  thumbnailUrl?: string;
}

// Combined Search Types

export type CombinedSearchGroupType =
  | "Destination"
  | "Attraction"
  | "Category"
  | "Product"
  | "Collection";

export interface CombinedSearchSuggestion {
  id: string;
  label: string;
  suggestionType: string;
  subLabel?: string;
  thumbnailUrl?: string;
  reviewAverage?: number;
  reviewCount?: number;
  activityCount?: number;
  trackingPropertiesV2?: TrackingProperties;
  destinationId?: string;
  destinationName?: string;
}

export interface CombinedSearchGroup {
  groupType: CombinedSearchGroupType;
  suggestions: CombinedSearchSuggestion[];
}

export interface CombinedAutocompleteResponse {
  groups: CombinedSearchGroup[];
}

export interface CombinedAutocompleteRequest {
  query: string;
  destinationId?: string;
  /** Location label for resolving destinationId when not available (e.g., shop page) */
  locationLabel?: string;
  attractionId?: string;
  categoryId?: string;
}

export type CombinedSearchPageContext = "landing" | "availability" | "shop";

/** Configurable max results per group heading in the dropdown */
export const MAX_RESULTS_PER_GROUP = 3;

export const COMBINED_GROUP_TO_ENTRY_TYPE: Record<CombinedSearchGroupType, ActivitiesEntryTypeEnum | undefined> = {
  Destination: ActivitiesEntryTypeEnum.COMBINED_SEARCH_DESTINATION,
  Category: ActivitiesEntryTypeEnum.COMBINED_SEARCH_CATEGORY,
  Attraction: ActivitiesEntryTypeEnum.COMBINED_SEARCH_ATTRACTION,
  Product: ActivitiesEntryTypeEnum.COMBINED_SEARCH_PRODUCT,
  Collection: undefined,
};
